export enum ECopyMoveModalType {
  COPY = 'COPY',
  MOVE = 'MOVE',
}
